import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['startAtDatePicker', 'endAtDatePicker'];

  setMaxEndDate() {
    this.endAtDatePickerTarget.min = this.startAtDatePickerTarget.value;
  }

  setMinStartDate() {
    this.startAtDatePickerTarget.max = this.endAtDatePickerTarget.value;
  }
}
